module.exports = __webpack_public_path__ + "static/media/y1479.869ca18.mp3";


//////////////////
// WEBPACK FOOTER
// ./src/assets/audios/y1479.mp3
// module id = pKiK
// module chunks = 1